<template>
  <div class="text-center">
    <div class="border-btm-1">
      <ul style="padding: 0 20px">
        <li
          v-for="(item, index) in messageList"
          :key="index"
          @click="getMsgInfo(item)"
        >
          <span
            style="
              width: 600px;
              display: inline-block;
              float: left;
              text-align: left;
            "
            class="elipsis-class"
          >
            {{ item.title }}
          </span>
          <span style="float: right">{{ item.publishTime }}</span>
        </li>
      </ul>
    </div>
    <el-pagination
      style="margin: 20px 0"
      layout="->, prev,pager,next,total,sizes,jumper"
      @size-change="changeSize"
      @current-change="changeCurrent"
      :page-size="pageData.pageSize"
      :page-sizes="['10', '20', '30', '40', '50']"
      :current-page="pageData.pageNumber"
      :pager-count="7"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
export default {
  props: {
    activeId: {
      type: String,
    },
  },
  data() {
    return {
      total: 0,
      pageData: {
        pageSize: 10,
        pageNumber: 1,
      },
      messageList: [],
    };
  },
  watch: {
    messageList: {
      handler(newval, oldval) {
        if (this.messageList.length > 0 && this.$route.params.id === 'deptDuty') {
          this.getMsgInfo(this.messageList[0])
        }
      },
      deep: true,
    },
  },
  methods: {
    changeSize(value) {
      this.pageData.pageSize = value;
      this.getMsgList();
    },
    changeCurrent(value) {
      this.pageData.pageNumber = value;
      this.getMsgList();
    },
    getMsgList() {
      this.messageList = []
      const param = {
        pageSize: this.pageData.pageSize,
        pageNum: this.pageData.pageNumber,
        categoryId: this.activeId || this.$route.params.id,
      };
      if (param.categoryId === 'xwtz') {
        param.categoryId = null;
        param.publishModel = 2;
      }
      this.$api.index.getMsgList(param).then((res) => {
        if (res.code === 200) {
          if (res.data.content.length > 0) {
            res.data.content.forEach((item) => {
              item.publishTime = item.publishTime.split("T")[0];
            });
          }
          this.messageList = res.data.content;
          this.total = res.data.totalElements;
        }
      });
    },
    getMsgInfo(item) {
      this.$router.push({
        path: "/detail/" + item.id,
        query: {
          nochange: true
        }
      });
    },
  },
  mounted() {
    this.getMsgList();
  },
};
</script>

<style scoped lang='less'>
.mar-right-10 {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}
.active-class {
  border-left: 2px solid #650004;
  background: #ffeff0;
}
.elipsis-class {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
ul li {
  list-style: initial;
  padding: 25px 0 0;
  cursor: pointer;
}
ul li::marker {
  color: red;
}
</style>
